const ORIGINS = {
  role: "MissionRole",
};

export default ORIGINS;
